// Mock data for the talent platform

export const jobCategories = [
  { id: 'ai', name: 'AI & Machine Learning', icon: 'Brain' },
  { id: 'tech', name: 'Software Engineering', icon: 'Code' },
  { id: 'finance', name: 'Finance & Analytics', icon: 'TrendingUp' },
  { id: 'healthcare', name: 'Healthcare & Biotech', icon: 'Heart' },
  { id: 'general', name: 'General', icon: 'Briefcase' },
];

export const roles = [
  {
    id: '1',
    title: 'Senior AI Engineer',
    company: 'TechCorp AI',
    category: 'ai',
    payRange: '$150-$200/hr',
    type: 'Full-time',
    location: 'Remote',
    description: 'Lead AI model development and deployment for cutting-edge applications.',
    requirements: ['5+ years ML experience', 'Python, PyTorch', 'LLM fine-tuning'],
    hiredRecently: 45,
    postedDate: '2025-07-10',
  },
  {
    id: '2',
    title: 'Full Stack Developer',
    company: 'StartupX',
    category: 'tech',
    payRange: '$80-$120/hr',
    type: 'Contract',
    location: 'Remote',
    description: 'Build scalable web applications using modern tech stack.',
    requirements: ['React/Next.js', 'Node.js', 'PostgreSQL/MongoDB'],
    hiredRecently: 128,
    postedDate: '2025-07-12',
  },
  {
    id: '3',
    title: 'Quantitative Analyst',
    company: 'FinanceHub',
    category: 'finance',
    payRange: '$120-$180/hr',
    type: 'Full-time',
    location: 'Hybrid',
    description: 'Develop quantitative models for trading strategies and risk management.',
    requirements: ['Advanced statistics', 'Python/R', 'Financial modeling'],
    hiredRecently: 23,
    postedDate: '2025-07-08',
  },
  {
    id: '4',
    title: 'Healthcare Data Scientist',
    company: 'MedTech Solutions',
    category: 'healthcare',
    payRange: '$100-$150/hr',
    type: 'Full-time',
    location: 'Remote',
    description: 'Apply ML to healthcare data for predictive diagnostics and patient outcomes.',
    requirements: ['Healthcare domain', 'ML/AI', 'HIPAA compliance'],
    hiredRecently: 34,
    postedDate: '2025-07-11',
  },
  {
    id: '5',
    title: 'Product Manager',
    company: 'InnovateCo',
    category: 'general',
    payRange: '$90-$140/hr',
    type: 'Contract',
    location: 'Remote',
    description: 'Lead product strategy and roadmap for B2B SaaS products.',
    requirements: ['5+ years PM experience', 'Agile/Scrum', 'Technical background'],
    hiredRecently: 67,
    postedDate: '2025-07-09',
  },
  {
    id: '6',
    title: 'ML Research Scientist',
    company: 'DeepMind Labs',
    category: 'ai',
    payRange: '$180-$250/hr',
    type: 'Full-time',
    location: 'Remote',
    description: 'Conduct cutting-edge research in deep learning and neural architectures.',
    requirements: ['PhD in ML/AI', 'Published papers', 'PyTorch/JAX'],
    hiredRecently: 12,
    postedDate: '2025-07-13',
  },
  {
    id: '7',
    title: 'DevOps Engineer',
    company: 'CloudScale',
    category: 'tech',
    payRange: '$100-$150/hr',
    type: 'Contract',
    location: 'Remote',
    description: 'Build and maintain CI/CD pipelines and cloud infrastructure.',
    requirements: ['AWS/GCP', 'Kubernetes', 'Terraform'],
    hiredRecently: 89,
    postedDate: '2025-07-10',
  },
  {
    id: '8',
    title: 'Investment Analyst',
    company: 'Capital Partners',
    category: 'finance',
    payRange: '$110-$160/hr',
    type: 'Full-time',
    location: 'Hybrid',
    description: 'Analyze investment opportunities and conduct due diligence.',
    requirements: ['CFA preferred', 'Financial modeling', 'M&A experience'],
    hiredRecently: 18,
    postedDate: '2025-07-07',
  },
];

export const stats = {
  averageHourlyRate: 86,
  rolesCreated: 55000,
  dailyPayouts: 2000000,
  peopleHiredLastWeek: 721,
};

export const interviewQuestions = [
  {
    id: 1,
    category: 'behavioral',
    question: 'Tell me about a challenging project you worked on and how you overcame obstacles.',
  },
  {
    id: 2,
    category: 'technical',
    question: 'Describe your experience with the technologies listed in your resume.',
  },
  {
    id: 3,
    category: 'situational',
    question: 'How do you handle tight deadlines and competing priorities?',
  },
];

export const skillsList = [
  'JavaScript', 'TypeScript', 'Python', 'Java', 'C++', 'Go', 'Rust',
  'React', 'Vue.js', 'Angular', 'Node.js', 'Django', 'FastAPI',
  'Machine Learning', 'Deep Learning', 'NLP', 'Computer Vision',
  'AWS', 'GCP', 'Azure', 'Docker', 'Kubernetes',
  'SQL', 'MongoDB', 'PostgreSQL', 'Redis',
  'Financial Modeling', 'Risk Analysis', 'Trading Systems',
  'Healthcare Analytics', 'Clinical Data', 'HIPAA',
  'Product Management', 'Agile', 'Scrum', 'Leadership'
];
